// ===================================================================
// THIS FILE WAS AUTO GENERATED DO NOT EDIT IMPLACE
// ===================================================================
/* eslint-disable @typescript-eslint/no-duplicate-enum-values */

export enum ECpmCUserTypeApiEnum {
    SUPER_ADMIN = 'SUPER_ADMIN',
    SUPER_ADMIN_M2M = 'SUPER_ADMIN_M2M',
    USER = 'USER',
    M2M = 'M2M'
}

/**
 * Enum value type by enum value (AKA Reversed enum)
 */
export const RECpmCUserTypeApiEnum = Object.fromEntries(
    Object.entries(ECpmCUserTypeApiEnum)
        .map(([key, value]) => [
            value,
            key as ECpmCUserTypeApiEnum
        ])
);


// ===============================================================
// ===============================================================

export enum ECpmCUserRoleTypeApiEnum {
    GLOBAL = 'GLOBAL',
    MULTI_SCHEMA_TENANT_ROLE = 'MULTI_SCHEMA_TENANT_ROLE'
}

/**
 * Enum value type by enum value (AKA Reversed enum)
 */
export const RECpmCUserRoleTypeApiEnum = Object.fromEntries(
    Object.entries(ECpmCUserRoleTypeApiEnum)
        .map(([key, value]) => [
            value,
            key as ECpmCUserRoleTypeApiEnum
        ])
);


// ===============================================================
// ===============================================================

/**
 * Route Types
 */
export enum ECpmCRouteTypeApiEnum {
    READ = 'READ',
    CREATE = 'CREATE',
    DELETE = 'DELETE',
    UPDATE = 'UPDATE',
    PATCH = 'PATCH'
}

/**
 * Enum value type by enum value (AKA Reversed enum)
 */
export const RECpmCRouteTypeApiEnum = Object.fromEntries(
    Object.entries(ECpmCRouteTypeApiEnum)
        .map(([key, value]) => [
            value,
            key as ECpmCRouteTypeApiEnum
        ])
);


// ===============================================================
// ===============================================================

/**
 * Resource Access
 */
export enum ECpmCResourceAccessApiEnum {
    SUPER_ADMIN_ONLY = 'SUPER_ADMIN_ONLY',
    ANONYMOUS = 'ANONYMOUS',
    ANY_LOGGED_IN = 'ANY_LOGGED_IN',
    EXPLICIT = 'EXPLICIT'
}

/**
 * Enum value type by enum value (AKA Reversed enum)
 */
export const RECpmCResourceAccessApiEnum = Object.fromEntries(
    Object.entries(ECpmCResourceAccessApiEnum)
        .map(([key, value]) => [
            value,
            key as ECpmCResourceAccessApiEnum
        ])
);

